(function($){

	var disabledClass = 'smart-list-disabled';

	$(document).ready(initAlphabetical);

	function initAlphabetical(){
		var alphaLists = $('.smart-list-alphabetical');
		if( alphaLists.length ){
			processLists(alphaLists);
		}
	}

	function processLists( lists ){
		var $anchors = lists.find('[id^=sectionSpecial_] li a[href]'),
			$anchor, $list, listID;
		for ( var i = 0; i < $anchors.length; i++ ){
			$anchor = $($anchors[i]);
			$list = $anchor.closest('ul.list');
			if( !$list.hasClass(disabledClass) ){
				continue;
			}
			listID = $list.attr('id');
			insertRefLink(listID);
		}
	}

	function insertRefLink(listID){
		var splitID = listID.split('_'),
			idIndex = "#referenceSpecial_" + splitID[1],
			refText = $(idIndex).text().trim(),
			bookmark = '<a href=#' + listID + '>' + refText + '</a>';
		$(idIndex).html(bookmark);
	}

	
}(window.jQuery));

// Analytics

analytics.eventConfig.push(
    {
        "target": ".component.a08-smartlist",
        "codeId": "a08",
        "events": [
            {
                "eventTarget": ".list li a:not([href*=\\http])",
                "eventType": "click",
                "tags": {
                    "event": "navigation",
                    "componentId": "a08",
                    "componentName": "smart list flat",
                    "eventType": "smart list internal navigation click",
                    "elementType": "smart list link",
                    "elementText": "",
                    "destinationUrl": "",
                    "listOrdinal": {
                        "ref": "ul",
                        "ele": "a"
                    },
                    "listSource": "",
                    "parentName": "",
                    "parentTitle": ""
                }
            }
        ]
    },
    {
        "target": ".component.a09-smart-list",
        "codeId": "a09",
        "events": [
            {
                "eventTarget": ".list li a:not([href*=\\http])",
                "eventType": "click",
                "tags": {
                    "event": "navigation",
                    "componentId": "a09",
                    "componentName": "smart list alpha",
                    "eventType": "smart list internal navigation click",
                    "elementType": "smart list link",
                    "elementText": "",
                    "destinationUrl": "",
                    "listOrdinal": {
                        "ref": "ul",
                        "ele": "a"
                    },
                    "listSource": "",
                    "parentName": "",
                    "parentTitle": ""
                }
            }
        ]
    },
    // PSE product search equipment
    {
        "target": ".smart-list",
        "codeId": "pse",
        "events": [
            {
                "eventTarget": "#equipmentBuilder a.equipmentengine",
                "eventType": "click",
                "tags": {
                    "componentId": "pse",
                    "componentName": "search equipment",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "manufacturer link",
                    "event": "navigation",
                    "eventType": "manufacturer internal navigation click",
                    "listOrdinal": {
                        "ref": "#equipmentBuilder",
                        "ele": "a"
                    }
                }
            },
            {
                "eventTarget": "#equipment a",
                "eventType": "click",
                "tags": {
                    "componentId": "pse",
                    "componentName": "search equipment",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "equipment model link",
                    "event": "navigation",
                    "eventType": "equipment model internal navigation click",
                    "listOrdinal": {
                        "ref": "#equipment",
                        "ele": "a"
                    }
                }
            }
        ]
    },
)